
import { Syringe, Pill, Droplet } from 'lucide-react';
import { Medication } from './index';

export const peptidesMedications: Medication[] = [
  {
    id: '24',
    name: 'Sermorelin',
    description: 'A growth hormone-releasing hormone (GHRH) analog that stimulates the natural production of growth hormone, improving muscle tone, energy, and recovery.',
    research: 'Sermorelin and GH - Sermorelin, a GHRH analog, boosts growth hormone levels, improving lean mass and energy in adults. Studies show a 50-100% GH increase with nightly dosing.',
    url: 'https://www.sciencedirect.com/science/article/abs/pii/S109663740080035X',
    category: 'peptides',
    Icon: Syringe,
    video: 'https://www.youtube.com/watch?v=2h2KxYfGJzY',
    availablePreparations: 'Injection (e.g., 1 mg/ml), Sublingual Troches (e.g., 300 mcg with Testosterone/Oxytocin/Tadalafil)',
    clinicalDetails: {
      dosingGuidelines: 'Injection: 0.2-0.5 mg SC nightly (compounded). Troches: 300 mcg daily (compounded).',
      administrationProtocols: 'Injection: Subcutaneous in abdomen or thigh before bed. Troches: Place under tongue until dissolved.',
      contraindications: 'Hypersensitivity, active malignancy, untreated hypothyroidism.',
      monitoringRequirements: 'Monitor IGF-1, GH levels; assess energy, muscle changes, injection site reactions.'
    },
    adverseReactions: {
      common: 'Injection site reactions, headache, flushing.',
      lessCommon: 'Dizziness, nausea.',
      rare: 'Hyperactivity, allergic reactions.'
    }
  },
  {
    id: '25',
    name: 'Rapamycin (Sirolimus)',
    description: 'An mTOR inhibitor that promotes longevity and cellular repair. It is used in anti-aging protocols and for immune modulation.',
    research: 'Rapamycin and Aging - Rapamycin inhibits mTOR, extending lifespan in animal models by 10-20% and enhancing cellular repair. Human anti-aging use is emerging but lacks large-scale trials.',
    url: 'https://www.nature.com/articles/nrm3496',
    category: 'peptides',
    Icon: Pill,
    availablePreparations: 'Oral Capsules (e.g., 6 mg, 8 mg, 9 mg)',
    clinicalDetails: {
      dosingGuidelines: '2-6 mg PO weekly (off-label; investigational).',
      administrationProtocols: 'Oral, with or without food; weekly dosing common in anti-aging.',
      contraindications: 'Hypersensitivity, active infection, severe hepatic impairment.',
      monitoringRequirements: 'Monitor renal function, CBC, lipids; assess infection risk, mouth sores.'
    },
    adverseReactions: {
      common: 'Mouth sores, diarrhea, acne.',
      lessCommon: 'Hyperlipidemia, thrombocytopenia.',
      rare: 'Interstitial lung disease, infection risk.'
    }
  },
  {
    id: '26',
    name: '5-Amino-1MQ',
    description: 'A small molecule that targets nicotinamide N-methyltransferase (NNMT), potentially supporting fat loss and metabolic health.',
    research: 'NNMT Inhibitors - 5-Amino-1MQ inhibits NNMT, increasing NAD+ and fat oxidation in preclinical models. It shows potential for obesity and in metabolic health, though human data is limited.',
    url: 'https://www.cell.com/cell-metabolism/fulltext/S1550-4131(19)30319-6',
    category: 'peptides',
    Icon: Pill,
    availablePreparations: 'Oral Capsules (e.g., 50 mg)',
    clinicalDetails: {
      dosingGuidelines: '50-100 mg PO daily (investigational; compounded).',
      administrationProtocols: 'Oral, with or without food (limited human data).',
      contraindications: 'Hypersensitivity; caution in metabolic disorders (limited data).',
      monitoringRequirements: 'Monitor weight, metabolic markers (e.g., glucose, lipids); assess GI tolerance.'
    },
    adverseReactions: {
      common: 'GI upset, headache (based on early data).',
      lessCommon: 'Fatigue, rash.',
      rare: 'Unknown (limited human data).'
    }
  },
  {
    id: '31',
    name: 'GHK-Cu',
    description: 'A copper peptide promoting skin repair, wrinkle reduction, and hair growth via collagen production and antioxidants.',
    research: 'GHK-Cu in Skin Repair - This copper peptide improves skin elasticity and hair density in aging populations via collagen synthesis and growth factor modulation.',
    url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC6073405/',
    category: 'peptides',
    Icon: Droplet,
    availablePreparations: 'Topical Ointment (e.g., 0.5% facial), Topical Solution (e.g., 0.5% hair)',
    clinicalDetails: {
      dosingGuidelines: 'Apply 0.5% ointment/solution to face or scalp daily (compounded).',
      administrationProtocols: 'Topical to clean, dry skin or scalp; massage gently.',
      contraindications: 'Hypersensitivity to copper peptides; avoid in open wounds.',
      monitoringRequirements: 'Monitor skin/scalp irritation; assess cosmetic outcomes (e.g., texture, hair growth).'
    },
    adverseReactions: {
      common: 'Skin irritation, redness.',
      lessCommon: 'Itching, rash.',
      rare: 'Allergic reactions, copper toxicity (excessive use).'
    }
  }
];
